import {useEffect, useState} from 'react';
import dayjs from 'dayjs';
import { DemoContainer, DemoItem } from '@mui/x-date-pickers/internals/demo';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import {fetchPOCUploadedIndividualList} from "../Redux/BussinessPOCSlice";
import { useDispatch } from "react-redux";
import "./MyNominationDateFilter.css";

export default function MyNominationDateFilter({userEnterpriseID}) {
  const [startDate, setStartDate] = useState(dayjs('2023-01-01'));
  const [endDate, setEndDate] = useState(dayjs());

  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(fetchPOCUploadedIndividualList(userEnterpriseID,startDate.format('D/M/YYYY'),endDate.format('D/M/YYYY')));    
  }, [startDate,endDate]);  

  return <div className='my_nomination_date_filter'>
    {/* <span className='date_label'>Select Date:</span> */}
    <LocalizationProvider dateAdapter={AdapterDayjs}>
      <DemoContainer components={['DatePicker']}>                
        <DemoItem>
          <DatePicker value={startDate} onChange={(newValue) => setStartDate(newValue)} />          
        </DemoItem>
        <span className='date_to_text'>to</span>
        <DemoItem>
          <DatePicker value={endDate} onChange={(newValue) => setEndDate(newValue)} />
        </DemoItem>                
      </DemoContainer>
    </LocalizationProvider>
  </div>
}
